import { saveAs } from 'file-saver';
import moment from 'moment';
import * as qs from 'qs';
import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Alert from 'react-s-alert';
import * as apx from '../api/apxService';
import { url } from './general/generalUtil';
import { redirectToUrl } from '../general/generalUtil';
import { CustomTooltip } from './general/CustomTooltip';
import { FormatMessageDiv } from './general/FormatMessageDiv';
import ComponentHeader from './header/ComponentHeader';

export class Report extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      report: null,
      loadingPdf: false,
      loadingReport: true,
    };
  }

  async componentDidMount() {
    moment.locale(this.props.language);
    try {
      const { id } = this.props.match.params;
      const report = await apx.get(apx.service.report, `?id=${id}`);
      if (report.page.total === 1) {
        const groupName = await apx.get(apx.service.groups, `?id=${report.data[0].group_id}`);
        report.data[0].group = groupName.data[0].name;
        this.setState({ report: report.data[0], loadingReport: false });
        const download = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dl;
        if (download) {
          if (Number(download) === 1 && report.data[0].status === 'COMPLETE') {
            await this.download(id, moment().valueOf);
          }
        }
      } else {
        this.setState({ loadingReport: false });
        await apx.post(apx.service.logout);
        redirectToUrl(`${url.pages}/login/?redirect=${encodeURIComponent(window.location.href)}`);
      }
    } catch (e) {
      const error:any = await e;
      if (error.code === 104 || error.code === 108) {
        redirectToUrl(`${url.pages}/login/?redirect=${encodeURIComponent(`${url.pages}/myreports/${location.hash}`)}`);
      } else {
        this.setState({ loadingReport: false });
        Alert.error(this.props.intl.formatMessage({ id: 'error' }), { position: 'bottom-left', effect: 'slide' });
      }
    }
  }

  async handleSubmit(id: string, timestamp: any) {
    await this.download(id, timestamp);
  }

  async download(id: string, timestamp: any) {
    this.setState({ loadingPdf: true });
    try {
      const download = await apx.get(apx.service.report, `${id}/pdf/${this.props.language}`);
      saveAs(download, `FIB_report${moment(Number(timestamp)).format('YYYY-MM-DD')}.pdf`);
    } catch (error) {
      Alert.error(this.props.intl.formatMessage({ id: 'error' }), { position: 'bottom-left', effect: 'slide' });
    }
    this.setState({ loadingPdf: false });
  }

  render() {
    const { report } = this.state;

    const Header = () => (
      <ComponentHeader language={this.props.language} changeLang={({ key }: any) => { this.props.changeLanguage(key); }} />
    );

    if (report) {
      return (
        <div className="container">
          <div className="center-div">
            <Header />
            <div className="box">
              <div className="row">
                <div className="col-sm-4 box-content">
                  <div className="box-left">
                    <div className="reason">
                      <FormattedMessage id={report.trigger} defaultMessage="Prescription expired" />
                    </div>
                    <FormatMessageDiv className="titles" id="period" defaultMessage="PERIOD" />
                    { moment(report.content.start_timestamp).format('DD MMM YYYY') } &rarr; &nbsp;
                    { moment(report.content.end_timestamp).format('DD MMM YYYY') }
                    <FormatMessageDiv className="titles" id="group" defaultMessage="GROUP" />
                    { report.group }
                    <FormatMessageDiv className="titles" id="status" defaultMessage="STATUS" />
                    {
                      report.status === 'COMPLETE' ? (
                        <div className="item">
                          <FormatMessageDiv className="label label-green" id="complete" defaultMessage="COMPLETE" /> &nbsp;
                          <CustomTooltip color="color-green" message={this.props.intl.formatMessage({ id: 'infoComplete' })} />
                        </div>
                      ) : (
                        <div className="item">
                          <FormatMessageDiv className="label" id="incomplete" defaultMessage="INCOMPLETE" /> &nbsp;
                          <CustomTooltip message={this.props.intl.formatMessage({ id: 'infoIncomplete' })} />
                        </div>
                      )
                    }
                    <FormatMessageDiv className="titles" id="date" defaultMessage="DATE" />
                    { moment(report.creation_timestamp).format('DD MMM YYYY LT') }
                  </div>
                </div>
                <div className="col-sm-8">
                  <i className="fa fa-file fa-7x file-icon" />
                  <button
                    className="btn download-btn"
                    disabled={report.status !== 'COMPLETE' || this.state.loadingPdf}
                    onClick={() => this.handleSubmit(report.id, report.creation_timestamp)}
                  >
                    {
                      this.state.loadingPdf ? <FormattedMessage id="wait" defaultMessage="Please wait ..." /> :
                        <FormattedMessage id="download" defaultMessage="Download" />
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container">
        <div className="center-div">
          <ComponentHeader language={this.props.language} changeLanguage={({ key }: any) => { this.props.changeLanguage(key); }} />
          {
            this.state.loadingReport ? <i className="fa fa-spinner fa-pulse fa-fw loader-green" /> :
              <FormattedMessage id="notFound" defaultMessage="Report not found" />
          }
        </div>
      </div>
    );
  }
}

export default injectIntl(Report);
